import {createApi} from '@reduxjs/toolkit/query/react';
import {baseQuery} from '@store/baseQuery';

export interface ITariffsQuestion {
    id: number;
    question: string;
    answer: string;
    sort_order: number;
}

export interface ITariffsQuestionsResponse {
    questions: ITariffsQuestion[];
}

export interface ITariff {
    id: number;
    users_count: number;
    duration_days: number;
    price: string;
    is_default: boolean;
}

export interface ITariffsResponse {
    tariffs: ITariff[];
}

export const TariffsPageApi = createApi({
    reducerPath: 'tariffsPageApi',
    baseQuery: baseQuery(),
    endpoints: (builder) => ({
        // Публичный список тарифов из sys_rates (то же, что редактируется в Orchid)
        getTariffs: builder.query<ITariffsResponse, void>({
            query: () => ({url: '/tariffs'}),
            keepUnusedDataFor: 0,
        }),
        getTariffsQuestions: builder.query<ITariffsQuestionsResponse, void>({
            query: () => ({url: '/tariffs/questions'}),
        }),
    }),
});

export const {useGetTariffsQuery, useGetTariffsQuestionsQuery} = TariffsPageApi;
